import React from "react";
import { CITIES } from "../mock";
import { Reveal } from "../hooks/useReveal";
import { MapPin } from "lucide-react";

export default function Cities() {
  return (
    <section id="cities" className="relative py-24 bg-[#0a0e0c] border-y border-white/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">Where we ride</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            Proudly Nigerian, rolling out nationwide
          </h2>
          <p className="mt-4 text-white/60 text-lg">
            An indigenous company built for Nigeria. We&apos;re rolling out city by city &mdash; here&apos;s where InstantDrive is headed first.
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {CITIES.map((c, i) => (
            <Reveal key={c.name} delay={i * 110}>
              <div className="group relative rounded-3xl overflow-hidden border border-white/10 h-80">
                <img
                  src={c.image}
                  alt={c.name}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-[#2fd645] px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-[#06210b]">
                    <MapPin className="h-3 w-3" /> {c.status}
                  </span>
                  <h3 className="mt-3 font-display font-extrabold text-white text-3xl">{c.name}</h3>
                  <p className="mt-1 text-sm text-white/70">{c.blurb}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
